import api from "./axios";

/**
 * Exporte les situations de facturation des appareils vers un fichier Excel
 * @param {string} startDate - Date de début au format YYYY-MM-DD
 * @param {string} endDate - Date de fin au format YYYY-MM-DD
 * @returns {Promise} - Réponse de l'API
 */
export async function exportOrderInvoiceData(startDate, endDate) {
  try {
    const response = await api.get("/exports/invoice-situations", {
      params: { startDate, endDate },
      responseType: "blob", // Important pour télécharger le fichier
    });

    // Création d'un lien pour télécharger le fichier
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    
    // Extraction du nom de fichier depuis l'en-tête de réponse ou génération d'un nom par défaut
    const contentDisposition = response.headers["content-disposition"];
    let filename = "situations-facturation.xlsx";
    
    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }
    
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    
    // Nettoyage
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return response;
  } catch (error) {
    console.error("Erreur lors de l'exportation", error);
    throw error;
  }
}